import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';

import { AplicacionContratoComponent} from '../../aplicaciones/aplicacion-contrato/aplicacion-contrato.component';
import {ProrrogasComponent} from '../../contrato/prorrogas/prorrogas.component';
import {OtroSiComponent} from '../../contrato/otro-si/otro-si.component';
import { MatDialog } from '@angular/material/dialog';
import { ContratoService } from './contrato.service';
import { ClientesService } from '../clientes.service';
import * as moment from 'moment';
import { MensajeService } from 'src/app/generico/servicio/mensaje.service';
import { ModuloService } from 'src/app/modulo/modulo.service';

@Component({
  selector: 'app-crear-contrato',
  templateUrl: './crear-contrato.component.html',
  styleUrls: ['./crear-contrato.component.scss']
})
export class CrearContratoComponent implements OnInit{
  contratoForm = this.fb.group({
    fk_cliente: null,
    fk_tipo_contrato: [null, Validators.required],
    fec_inicio: [null, Validators.required],
    fec_fin: [null],
    num_vlr_contrato: [null, [Validators.required]],
    txt_objeto: [null, Validators.required],
    id_contrato : [null],
    num_contrato :[null,[Validators.required]],
    ind_activo : [true]
  });

  id_contrato : number;
  tipo_contratos : any;
  ind_termino_fijo : boolean =  false;
  
  constructor(private fb: FormBuilder,
              public dialog: MatDialog,
              public contrato_serv : ContratoService, 
              private cli_serv : ClientesService,
              private msg_serv : MensajeService) {}

  ngOnInit(): void {
    
    this.contrato_serv
        .obtener_tipo_contrato()
        .then(()=>{ this.tipo_contratos = this.contrato_serv.json_tipo_contato});   
    
    if (this.contrato_serv.json_contrato){
      this.id_contrato = this.contrato_serv.json_contrato.id_contrato;
    }

    this.contratoForm.get('fk_cliente').setValue(this.cli_serv.json_cliente.txt_razon_social);
    this.contrato_serv.fec_fin_prorroga = null;
    this.llenar_forma();


  }

  onSubmit() {
    if(!this.contrato_serv.json_contrato){
      this.crear_contrato();
    }else{
      this.actualizar_contrato();
    }
  }

  crear_contrato(){
    let value = this.contratoForm.value;
    value.fk_cliente = this.cli_serv.json_cliente.id_cliente;

    delete value.id_contrato;

    let fec_ini : Date  = value.fec_inicio;
    let fec_fin : Date  = value.fec_fin;

    value.fec_inicio    = moment(fec_ini).format('DD/MM/YYYY');
    value.fec_fin       = moment(fec_fin).format('DD/MM/YYYY');

    this.contrato_serv
        .crear_contrato(value)
        .then(
          ()=>{

            if (this.contrato_serv.json_contrato){
              this.id_contrato = this.contrato_serv.json_contrato.id_contrato;
              this.contratoForm.get('id_contrato').setValue(this.id_contrato);
            }
          }
        );

  }

  abrirAplicacion() {
    const dialogRef = this.dialog.open(AplicacionContratoComponent, {
      width: '700px',
      height: '500px'
    });


  }

  abrirProrrogas() {
    const dialogRef = this.dialog.open(ProrrogasComponent, {
      width: '500px',
      /* height: '500px' */
    });

    let fec_inistr = this.contrato_serv.json_contrato.fec_ini_prorroga

    if (fec_inistr){
      this.contrato_serv.fec_inicio_prorroga = moment(fec_inistr, 'DD/MM/YYYY').toDate();
    }

    dialogRef.afterClosed().subscribe(result => {

      if(this.contrato_serv.fec_fin_prorroga){
        let str_msg = 'Al presionar el botón aceptar se guardará la prórroga.';
        this.msg_serv.ver_mensaje(str_msg, '', this.msg_serv.TIPO_INFO);
      }
    });

    this.contrato_serv.dialog_prorrogas = dialogRef;
  }

  abrirOtroSi() {
    const dialogRef = this.dialog.open(OtroSiComponent, {
      width: '500px',
      /* height: '500px' */
    });


  }

  evento_tipo_contrato(){
    this.ind_termino_fijo = this.contratoForm.value.fk_tipo_contrato == 1;
  }

  llenar_forma(){
    
    let json_contrato = this.contrato_serv.json_contrato;
    let json_cliente = this.cli_serv.json_cliente

    if (json_contrato){

      let fec_inicio = moment(json_contrato.fec_inicio, 'DD/MM/YYYY').toDate();
      let fec_fin = moment(json_contrato.fec_fin, 'DD/MM/YYYY').toDate();

      this.contratoForm.get('fk_cliente').setValue(json_cliente.txt_razon_social);
      this.contratoForm.get('fk_tipo_contrato').setValue(json_contrato.fk_tipo_contrato);
      this.contratoForm.get('fec_inicio').setValue(fec_inicio);
      this.contratoForm.get('fec_fin').setValue(fec_fin);
      this.contratoForm.get('num_vlr_contrato').setValue(json_contrato.num_vlr_contrato);
      this.contratoForm.get('txt_objeto').setValue(json_contrato.txt_objeto);
      this.contratoForm.get('id_contrato').setValue(json_contrato.id_contrato);
      this.contratoForm.get('ind_activo').setValue(json_contrato.ind_activo);
      this.contratoForm.get('num_contrato').setValue(json_contrato.num_contrato);

      if (!json_contrato.ind_activo){
        this.contratoForm.disable();
        this.contrato_serv.disabled = true;
      }
      this.evento_tipo_contrato()
    }
  }

  actualizar_contrato(){
    let value = this.contratoForm.value;
    let id_contrato = this.contrato_serv.json_contrato.id_contrato;
    let fec_ini : Date  = value.fec_inicio;
    let fec_fin : Date  = value.fec_fin;
    
    delete value.id_contrato;
    
    
    value.fk_cliente = this.cli_serv.json_cliente.id_cliente;
    value.fec_inicio    = moment(fec_ini).format('DD/MM/YYYY');
    value.fec_fin       = moment(fec_fin).format('DD/MM/YYYY');

    if (this.contrato_serv.fec_fin_prorroga){
      value['fec_fin_prorroga'] = moment(this.contrato_serv.fec_fin_prorroga).format('DD/MM/YYYY');
    }

    this.contrato_serv.actualizar_contrato(id_contrato, value);
  }

}
